import { useEffect } from 'react';
import { backButton } from '@tma.js/sdk';

import { useSession } from './store/session';
import { applyTheme, resolveTheme } from './theme/theme';
import { setVerticalSwipes } from './telegram/init';
import { PatternBackground } from './components/PatternBackground';
import { HomeScreen } from './features/home/HomeScreen';
import { SessionScreen } from './features/session/SessionScreen';
import { CompleteScreen } from './features/complete/CompleteScreen';
import { SettingsScreen } from './features/settings/SettingsScreen';
import { SalawatScreen } from './features/salawat/SalawatScreen';
import styles from './App.module.css';

export function App() {
  const screen = useSession((s) => s.screen);
  const activeSet = useSession((s) => s.activeSet);
  const themeMode = useSession((s) => s.settings.themeMode);
  const arabicScale = useSession((s) => s.settings.arabicScale);
  const exitSession = useSession((s) => s.exitSession);
  const closeSettings = useSession((s) => s.closeSettings);

  const inSession = screen === 'session';
  // На обоих экранах со счётчиком тап-зона занимает пол-экрана,
  // и свайп по ней сворачивает Mini App вместо отсчёта
  const hasTapTarget = inSession || screen === 'salawat';

  useEffect(() => {
    applyTheme(resolveTheme(themeMode, inSession ? activeSet : null));
  }, [themeMode, activeSet, inSession]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--arabic-scale',
      String(arabicScale),
    );
  }, [arabicScale]);

  // Свайп вниз сворачивает Mini App и конфликтует с большой
  // тап-зоной счётчика — глушим, пока она на экране.
  useEffect(() => {
    setVerticalSwipes(!hasTapTarget);
    return () => setVerticalSwipes(true);
  }, [hasTapTarget]);

  // Системная кнопка «назад» Telegram
  useEffect(() => {
    const onHome = screen === 'home';
    try {
      if (onHome) {
        backButton.hide();
        return;
      }
      backButton.show();
      return backButton.onClick(() => {
        if (screen === 'settings') closeSettings();
        else exitSession();
      });
    } catch {
      /* кнопка недоступна — навигация есть и внутри интерфейса */
    }
  }, [screen, exitSession, closeSettings]);

  return (
    <div className={styles.app}>
      <PatternBackground />
      <div className={styles.content}>
        {screen === 'home' && <HomeScreen />}
        {screen === 'session' && <SessionScreen />}
        {screen === 'complete' && <CompleteScreen />}
        {screen === 'settings' && <SettingsScreen />}
        {screen === 'salawat' && <SalawatScreen />}
      </div>
    </div>
  );
}
